import type {
    ConnectionRefContext,
    EditorRefContext,
    TextEditorContext,
    TextFile,
    SettingsContext,
} from '@pyranger/types';

export const BUFFER_DELAY = 100; // 100ms delay

export const DEFAULT_SETTINGS: SettingsContext = {
    useLinter: false,
    editorFontSize: 14,
    fileBrowserFontSize: 14,
    terminalFontSize: 14,
    saveBeforeRunning: true,
    showFileBrowser: true,
    showDebugTools: false,
    showRawOutput: false,
    fileBrowserFoldersFirst: true,
};

export const INITIAL_CONNECTION_CONTEXT: ConnectionRefContext = {
    connectCallback: null,
    connectionError: null,
    dataCallbacks: [],
    dataQueue: [],
    deviceInfo: null,
    disconnectCallback: null,
    disconnectionError: null,
    globalWriter: null,
    keepReading: false,
    loggingEnabled: true,
    manualDisconnect: false,
    port: null,
    portDisconnectHandler: null,
    reader: null,
    reconnectAttempts: 0,
    reconnectInterval: null,
    reconnectTarget: null,
    showResetRepl: false,
    lastSyncCheckResults: null,
};

export const INITIAL_REF_CONTEXT: EditorRefContext = {
    connectedDevice: {
        info: null,
    },
    connection: INITIAL_CONNECTION_CONTEXT,
    dataStream: {
        dataListeners: {},
    },
    // The `device` field is initialized with concrete class instances at runtime
    // in the editor layout (apps/web/src/app/(app)/editor/layout.tsx).
    // This placeholder satisfies the type checker.
    device: null as unknown as EditorRefContext['device'],
    devices: {
        currentDevice: null,
        knownDevices: [],
    },
    fileBrowser: {
        fileCache: null,
        selectedItem: null,
    },
    repl: {
        isExecutingCommand: false,
        isFileRunning: false,
    },
    terminal: {
        bufferTimeout: null,
        flushScheduled: false,
        instance: null,
        isTextSelected: false,
        messageBuffer: '',
        showRawOutput: false,
    },
    textEditor: {
        newFileCounter: 1,
        cancelExecutionEndCallback: null,
    },
};

export const INITIAL_TEXT_EDITOR_CONTEXT: TextEditorContext = {
    currentPath: null,
    openFiles: new Map<string, TextFile>(),
    savedFiles: [],
    refs: {},
};

export const FILE_BROWSER_ROOT_INDEX = 'root';

export const FILE_BROWSER_TREE_ID = 'file-browser';

export const FILE_BROWSER_ROOT_ITEM = {
    index: FILE_BROWSER_ROOT_INDEX,
    data: {
        size: 0,
        name: FILE_BROWSER_ROOT_INDEX,
        path: `${FILE_BROWSER_ROOT_INDEX}/`,
    },
    isFolder: true,
    children: [],
};
